import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Type } from '@uswitch/spark.type';
import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'list',
  element: 'item'
});
var iconPath = getVariantPath({
  id: 'list',
  element: 'icon'
});
var contentPath = getVariantPath({
  id: 'list',
  element: 'content'
});

var withColor = function withColor(color) {
  return {
    svg: {
      color: color
    }
  };
};

export var ListItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'li' : _ref$as,
      icon = _ref.icon,
      title = _ref.title,
      iconColor = _ref.iconColor,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "icon", "title", "iconColor", "children"]);

  return _jsxs(As, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: variantPath(title ? 'withTitle' : 'base')
    }
  }, props), {}, {
    children: [icon && _jsx("span", {
      sx: _objectSpread({
        variant: iconPath()
      }, iconColor && withColor(iconColor)),
      children: icon
    }), _jsxs("span", {
      children: [title && _jsx("header", {
        children: _jsx(Type.Bold1, {
          children: title
        })
      }), _jsx(Type.Body2, {
        sx: {
          variant: contentPath()
        },
        children: children
      })]
    })]
  }));
});
ListItem.propTypes = {
  /**
   * Optional item title can be passed as a prop
   */
  title: PropTypes.string,

  /**
   * Icon to be used as a bullet element
   */
  icon: PropTypes.element,

  /**
   * Icon color
   */
  iconColor: PropTypes.string
};
ListItem.defaultProps = {
  title: '',
  icon: null,
  iconColor: ''
};
ListItem.displayName = 'ListItem';